import { render, staticRenderFns } from "./Recency.vue?vue&type=template&id=45a7f3d4&scoped=true&"
import script from "./Recency.vue?vue&type=script&lang=js&"
export * from "./Recency.vue?vue&type=script&lang=js&"
import style0 from "./Recency.vue?vue&type=style&index=0&id=45a7f3d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7f3d4",
  null
  
)

export default component.exports